import {ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, InjectionToken, Input} from '@angular/core';
import {Observable} from 'rxjs';
import {share} from 'rxjs/operators';
import {destroy$} from '../destroyable';

export interface PartialLoading {
    readonly loading$: Observable<never>;
    getLoadingState(): boolean;
}

export const PARTIAL_LOADING = new InjectionToken<PartialLoading>('PartialLoading');

@Component({
    selector: 'partial-loading-indicator',
    templateUrl: './partial-loading-indicator.component.html',
    styleUrls: ['./partial-loading-indicator.component.scss'],
    providers: [
        {
            provide: PARTIAL_LOADING,
            useExisting: forwardRef(() => PartialLoadingIndicatorComponent)
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PartialLoadingIndicatorComponent implements PartialLoading {

    @Input('isLoading')
    public isLoadingExternal: boolean = false;

    public isLoadingSubscribed: boolean = false;

    public readonly loading$: Observable<never> = this.createLoadingStream();

    public readonly destroy$ = destroy$();

    constructor(
        private changeDetectorRef: ChangeDetectorRef
    ) {}

    public getLoadingState(): boolean {
        return this.isLoadingExternal || this.isLoadingSubscribed;
    }

    private createLoadingStream(): Observable<never> {
        return new Observable<never>(() => {
            this.isLoadingSubscribed = true;
            this.changeDetectorRef.markForCheck();

            return () => {
                this.isLoadingSubscribed = false;
                this.changeDetectorRef.markForCheck();
            };
        }).pipe(
            share()
        );
    }

}
